<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import type { TripSummarySegment } from '../../models';

import TripSummaryCardDesktop from './summaryCard/TripSummaryCardDesktop.vue';
import TripSummaryCardMobile from './summaryCard/TripSummaryCardMobile.vue';

interface TripPriceSummaryProps {
  priceSegments: TripSummarySegment[];
  hidePrices?: boolean;
}

const props = defineProps<TripPriceSummaryProps>();
const browserStore = useBrowserStore();
</script>

<template>
  <div class="trip-price-summary">
    <div v-if="props.priceSegments.length" class="price-segments">
      <div
        v-for="(priceSegment, index) in props.priceSegments"
        :key="index"
        class="price-segment"
      >
        <TripSummaryCardDesktop
          v-if="browserStore.isLargerThan1199px"
          class="trip-summary-card"
          :segment="priceSegment"
          :hide-prices="props.hidePrices"
        />
        <TripSummaryCardMobile
          v-else
          :segment="priceSegment"
          :hide-prices="props.hidePrices"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.trip-price-summary {
  .price-segments {
    display: flex;
    flex-direction: column;

    .price-segment {
      display: flex;
      gap: var(--spacing-8);
      color: var(--color-neutral-70);

      @include font-label-m-light;

      @include for-more-or-equal-than-1200-px {
        border-bottom: 1px solid var(--color-neutral-30);
      }

      &:not(:last-child) {
        border-bottom: 1px solid var(--color-neutral-30);
        padding-bottom: var(--spacing-24);
        margin-bottom: var(--spacing-24);

        @include for-less-or-equal-than-1199-px {
          padding-bottom: var(--spacing-16);
          margin-bottom: var(--spacing-16);
        }
      }

      &:last-child {
        padding-bottom: var(--spacing-16);
      }

      .trip-summary-card {
        flex: 1;
      }
    }
  }
}
</style>
